// extracted by mini-css-extract-plugin
module.exports = {"search__header":"default_search__header__E6kKy"};